<template>
    <v-expansion-panel>
        <v-expansion-panel-header>Medien</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row>
                <v-col class="col-12">
                    <v-row v-if="postItem.type === 'Rezept'" >
                        <v-col class="col-12">
                            <h3>Bilder Upload</h3>
                            <v-alert type="info">
                                Der Dateiname muss folgendem Format entsprechen xxxxx_Ziffer.png oder xxxxx_Ziffer.jpg
                            </v-alert>
                            <v-file-input multiple label="File input" @change="previewImages" :disabled="postItem.opener_images.length >= 6"></v-file-input>
                            <v-btn @click="deleteAllImages">Bilder löschen</v-btn>
                        </v-col>
                        <v-col
                                v-for="(sBimage, index) in postItem.opener_images"
                                :key="index"
                                class="d-flex child-flex"
                                cols="4"
                        >
                            <template v-if="!sBimage.deleted">
                                <v-hover>
                                    <v-img slot-scope="{ hover }"
                                            :src="postItem.opener_images[index].url"
                                            :lazy-src="postItem.opener_images[index].url"
                                            class="grey lighten-2"
                                           :alt="sBimage.name"
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                            >
                                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                        <v-fade-transition>
                                            <v-overlay
                                                    v-if="hover"
                                                    absolute
                                                    color="#036358"
                                            >
                                                <input type="file" :data-image-index="index" @change="previewImages" :ref="'imageUpload'+index" style="display:none;" />
                                                <v-icon title="Austauschen" @click="changeImage(index)" class="mr-3" color="#E6007E">mdi-pencil</v-icon>
                                                <!--<v-icon title="Löschen" @click="deleteImage(index)" v-bind:class="{ 'mr-3': !postItem.opener_images[index].preview}" color="#E6007E">delete</v-icon> -->
                                                <v-icon title="Vorschau" v-show="sBimage.preview == false" @click="setToPreview(index)" color="#E6007E">mdi-eye-settings</v-icon>
                                            </v-overlay>
                                        </v-fade-transition>
                                    </v-img>
                                </v-hover>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row v-if="postItem.type !== 'Rezept'">
                        <v-col>

                            <v-file-input label="Vorschaubild" @change="previewImages" :disabled="postItem.opener_images.length >= 1"></v-file-input>

                            <v-text-field
                                    v-model="postItem.opener_videos"
                                    label="YouTube ID"
                            ></v-text-field>

                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  export default {
    name: 'PostMediaComponent',
    props:['postItem'],
    data:() =>{
      return {
        reloadKey: 0,
        indFrDelImgs:[]
      }
    },
    methods:{
      compare(a, b) {
        let last5a=a.name.slice(-5);
        let last5b=b.name.slice(-5);
        let last1a=last5a.slice(0,1);
        let last1b=last5b.slice(0,1);
        if (last1a < last1b) {
          return -1;
        }
        if (last1a > last1b) {
          return 1;
        }
        return 0;
      },
      deleteAllImages(){
        this.postItem.opener_images = [];
      },
      previewImages(event) {

        console.log(event);

        // OnTour and Technikwelt Preview Image
        if(event instanceof File && (this.postItem.type === 'OnTour' || this.postItem.type === 'Technikwelt')){
          this.buildImageItem(event,0)
        }

        if(Array.isArray(event)){
          event.sort(this.compare);
          event.forEach( (item) => {
            this.buildImageItem(item,undefined)
          });
        }else{
          if(event instanceof File){
            console.log('instance if File');
            this.buildImageItem(event,undefined)
          }else{
            if(event.target !== undefined){
              let index = event.target.attributes['data-image-index'].value
              this.buildImageItem(event.target.files[0],index);
            }
          }
        }
      },
      changeImage(index){
        let refKey = 'imageUpload'+index;
        this.$refs[refKey][0].click()
      },
      deleteImage(index){
        this.indFrDelImgs.push(index);
        this.postItem.opener_images_deleted.push(this.postItem.opener_images[index])
        this.postItem.opener_images.splice(index,1);
        this.$forceUpdate();
      },
      setToPreview(index){
        let existingPreview = [false,0];
        this.postItem.opener_images.forEach((item,index) => {
          if(item.preview){
            existingPreview[0] = true;
            existingPreview[1] = index;
          }
        });
        if(existingPreview[0]){
          this.$store.dispatch('ask', {
            title: 'Bestehende Preview',
            body: 'Es besteht bereits ein Vorschaubild.\nSoll dieses ersetzt werden?',
          }).then(confirmation => {
            if(confirmation){
              this.postItem.opener_images[existingPreview[1]].preview = false;
              this.postItem.opener_images[index].preview = true;
              this.postItem.opener_images[existingPreview[1]].modified = true;
              this.postItem.opener_images[index].modified = true;
            }
          })
        }else{
          this.postItem.opener_images[index].preview = true;
          this.postItem.opener_images[index].modifed = true;
        }
        this.$forceUpdate();
      },
      buildImageItem(file,imageIndex){
        if(this.postItem.type !== 'Rezept'){
          if(!Array.isArray(this.postItem.opener_images)){
            this.postItem.opener_images = [];
          }
        }
        let newImageObject = {
          "modified":true,
          "preview": false,
          "name": "",
          "type": "",
          "tmp_name": "/tmp/php6bbi8j",
          "error": "0",
          "size": "0",
          "path": "media/image",
          "imageIndex": this.postItem.opener_images.length,
          "file": "",
          "url": "",
          "previewType": "image",
          "previewWidth": "",
          "previewHeight": ""
        }

        newImageObject.name = file.name
        newImageObject.file = file.name.replace(' ','_')
        newImageObject.type = file.type
        newImageObject.size = file.size

        if(newImageObject.file.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader ()
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          newImageObject.url = fr.result;
          if(imageIndex !== undefined){
            newImageObject.imageIndex = imageIndex;
            this.postItem.opener_images[imageIndex] = newImageObject;
          }else{
            if(this.postItem.type !== 'Rezept'){
              newImageObject.preview = true;
            }
            if(this.postItem.opener_images.length < 6){
              this.postItem.opener_images.push(newImageObject);
            }
          }
        })
      }
    }
  }
</script>